export default {
    category: {
        cta: "Voir les produits"
    }
}